/**
 * Item names for scanned codes (round 17: save and refusal lines read "Saving SNEHA-CFEARRINGSSANARED-RED-ONESIZE…",
 * "No free 5-ELE-5E-GR-11-GREEN-FREESIZE on BO-B02", while the worker knows the piece by its name). A screen that
 * knows what a SKU or barcode is registers its name; the scan box shows lines with each known code replaced by the
 * name. Display only: every check and every request still uses the code.
 */
const names = new Map<string, string>();

const norm = (code: string) => code.trim().toUpperCase();

/** The item named `name` is scanned as `code` (its SKU code or a barcode). */
export const nameScanCode = (code?: string, name?: string) => {
  if (!code || !name || !name.trim() || norm(code) === norm(name)) return;
  names.set(norm(code), name.trim());
};

/** The name registered for this code, else the code. */
export const scanName = (code: string) => names.get(norm(code)) ?? code;

/** A line with every registered code in it shown as its item name. */
export const named = <T extends string | undefined>(text: T): T => {
  if (!text || names.size === 0) return text;
  return text.replace(
    /[A-Za-z0-9][A-Za-z0-9_./-]*[A-Za-z0-9]/g,
    token => names.get(token.toUpperCase()) ?? token,
  ) as T;
};

/** Tests: forget every name. */
export const clearScanNames = () => names.clear();
